import React from "react";
import { connect } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import Routes from "./routes";
import { IRootState } from "./store/reducers";

import "./styles/index.scss";

const theme = createTheme();

export interface IAppProps extends StateProps, DispatchProps {}

export class App extends React.Component<IAppProps> {

  render() {
    return (
      <ThemeProvider theme={theme}>

      <div className="app">
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </LocalizationProvider>
      </div>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = ({ auth }: IRootState) => ({
  ...auth
});

const mapDispatchToProps = {

};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
